import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCLibraryWritingClassesConducted = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Writing classes conducted" />
    </Box>
  );
};
